import { apiSlice } from '..';
import { CreditRecommendation } from '../generated';

const recommendationsSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getYouMayAlsoLike: builder.query<CreditRecommendation[], string>({
            query: (code: string) => `/recommendations/you-may-also-like?code=${encodeURIComponent(code)}`,
            keepUnusedDataFor: 3600,
        }),
    }),
});

export const { useGetYouMayAlsoLikeQuery } = recommendationsSlice;
export default recommendationsSlice;
